import { getFullBox } from "@/components/occlusal/OcclusalTools.js";

function leaveHideMode() {
  if (vueApp.isHideMode) {
    console.log("leaveHideMode");
    vueApp.isHideMode = false;
    let visibleBox = getFullBox(true);
    let vcenter = visibleBox.center;
    vueApp.lookAtPoint(vcenter);
    $(".hide-mode-item").css("display", "none"); // 3.4
  }
}

function visibilityChangedHandler(item) {
  console.log(`visibilityChangedHandler`, item);
  if (vueApp.bones.includes(item)) {
    if (item.isMaxilla) {
      switchToggle("hideMaxillaDiv", item.isVisible);
    } else {
      switchToggle("hideMandibleDiv", item.isVisible);
    }
  }
  if (vueApp.nerves.includes(item)) {
    switchToggle("hideNervesDiv", item.isVisible);
  }

  if (vueApp.airways.includes(item)) {
    switchToggle("hideAirwaysDiv", item.isVisible);
  }

  if (vueApp.gingivae.includes(item)) {
    let anyVisible = vueApp.gingivae.find((x) => x.isVisible);
    switchToggle("hideGingivaeDiv", anyVisible);
  }

  if (vueApp.allTeeth.includes(item) && vueApp.isHideMode) {
    let mesh = viewer.get_model_mesh(item.id);
    mesh.visible = true;
    viewer.set_opacity(item.id, item.isVisible ? 1 : 0.3);
  }

  // let upperTeeth = vueApp.allTeeth.filter((x) => x.isUpper);
  // if (upperTeeth.includes(item)) {
  //   let anyVisible = upperTeeth.find((x) => x.isVisible);
  //   switchToggle("hideUpperDiv", anyVisible);
  // }

  // let lowerTeeth = vueApp.allTeeth.filter((x) => !x.isUpper);
  // if (lowerTeeth.includes(item)) {
  //   let anyVisible = lowerTeeth.find((x) => x.isVisible);
  //   switchToggle("hideLowerDiv", anyVisible);
  // }
}

export { leaveHideMode, visibilityChangedHandler };
